/* eslint-disable react/prop-types */

import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { getCommonPinningStyles } from './HeaderCell';
import ActionColumn from '../components/ActionColumn';

export const TableBody = ({
  table,
  loading,
  onAction,
  data,
  errorMsg,
  globalfilters
}) => {
  if (loading || !data.length) {
    return (
      <tbody>
        {/* <tr>
          <td
            colSpan={table.getAllColumns().length}
            className="text-center p-4"
          >
            {loading ? 'Loading...' : 'No data available'}
          </td>
        </tr> */}
        <h1
          className="text-center my-5"
          style={{
            color: '#6c757d',
            fontSize: '1.5rem',
            opacity: 0.7
          }}
        >
          {globalfilters.search_text != ''
            ? `"${globalfilters.search_text}", not found!`
            : errorMsg !== '' && errorMsg !== undefined
            ? errorMsg
            : 'No data added!'}
        </h1>
      </tbody>
    );
  }

  return (
    <tbody>
      {table.getRowModel().rows.map(row => (
        <tr key={row.id}>
          {row.getVisibleCells().map(cell => {
            // Check if the column header is 'Action' and render the ActionColumn component
            if (cell.column.id === 'action') {
              return (
                <td
                  key={cell.id}
                  className="fs--1"
                  style={{
                    ...getCommonPinningStyles(
                      cell.column,
                      table.getAllLeafColumns()
                    ),
                    overflow:
                      Object.keys(row?.original?.action).length > 2
                        ? 'visible'
                        : 'hidden'
                    // width: '400px'
                  }}
                >
                  {/* Render ActionColumn component */}
                  <ActionColumn
                    row={row}
                    handleAction={onAction}
                    cellProps={
                      null
                    } /* No need to pass cell props since we're already inside a td */
                  />
                </td>
              );
            }

            // Default behavior: render cell content
            return (
              <td
                key={cell.id}
                className="fs--1"
                style={{
                  ...getCommonPinningStyles(
                    cell.column,
                    table.getAllLeafColumns()
                  ),
                  width: cell.column.getSize(),
                  overflow: 'hidden'
                }}
              >
                <span className="text-truncate fs--1">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </span>
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};
